import React, { useState } from 'react';
import {
  ButtonContainer,
  ButtonText,
  SelectedContainer,
  SelectedItems,
  PopularItems,
  PopularItemsContainer,
  ModalTitle,
  BottomCTA,
  SearchContainer,
  MobileContainer,
  MobileContent,
  Note,
  SubTitle,
  TitleWrapper,
  TitleIcon,
} from '../../styles';
import InfoNote from 'src/international-insurance/components/landing-page/common/Note';
import SearchPage from '../search-page';
import Searchbar from '../search-box';
import DiamondIcon from '../../assets/icons/Diamond';
import { PrimaryButton } from '@acko-tech/building-blocks.ui.button';
import {
  useTheme,
  Colors,
  useColor,
} from '@acko-tech/building-blocks.ui.theme';
import { IValue } from '../../interface';
import { useViewport } from 'src/common/utils/responsive';
import ListItem from './list-item';
import ItemPill from './item-pill';

const Index = ({
  searchPlaceholder,
  popularValues,
  title,
  subTitle,
  totalValues,
  note,
  isInfoNote = false,
  continueCTA,
  updatedSelection,
  setUpdatedSelection,
  handleSubmit,
  hideContinueCta = false,
}) => {
  const { theme } = useTheme();
  const colors: Colors = useColor();
  const [searchInput, setSearchInput] = useState('');
  const [showSearch, setShowSearch] = useState(false);
  const { isMobile } = useViewport();

  const handleUpdate = (data: IValue) => {
    if (updatedSelection?.map(({ code }) => code)?.includes(data?.code)) {
      const newSelection = updatedSelection?.filter(({ code }) => {
        return code !== data?.code;
      });
      setUpdatedSelection(newSelection);
    } else setUpdatedSelection([...updatedSelection, data]);
  };

  return (
    <MobileContainer theme={theme} colors={colors}>
      <SearchContainer>
        <Searchbar
          placeholder={searchPlaceholder}
          onChange={(val) => setSearchInput(val)}
          onFocus={() => setShowSearch(true)}
          onBack={() => {
            setShowSearch(false);
            setSearchInput('');
          }}
          inFocus={showSearch}
        />
        {!!note &&
          (isInfoNote ? (
            <InfoNote text={note} />
          ) : (
            <Note>
              <DiamondIcon />
              {note}
            </Note>
          ))}
      </SearchContainer>
      {!showSearch && (
        <MobileContent isMobile={isMobile}>
          {updatedSelection?.length > 0 && (
            <SelectedContainer>
              <SelectedItems>
                {updatedSelection.map((item) => (
                  <ItemPill
                    key={item?.code}
                    item={item}
                    handleUpdate={() => handleUpdate(item)}
                  />
                ))}
              </SelectedItems>
            </SelectedContainer>
          )}
          {!!popularValues && popularValues?.length > 0 && (
            <PopularItemsContainer isDesktop={false} removeExtraMargin>
              <TitleWrapper>
                <ModalTitle marginBottom={isMobile ? '4px' : '20px'}>
                  {title}
                  <TitleIcon
                    src={
                      'https://acko-cms.ackoassets.com/trending_icon_676ca6fa84.png'
                    }
                  />
                </ModalTitle>
                {subTitle && <SubTitle>{subTitle}</SubTitle>}
              </TitleWrapper>
              <PopularItems>
                {popularValues?.map((item) => {
                  const checked = updatedSelection
                    ?.map(({ code }) => code)
                    ?.includes(item?.code);

                  return (
                    <ListItem
                      key={item?.code}
                      item={item}
                      checked={checked}
                      handleUpdate={() => handleUpdate(item)}
                    />
                  );
                })}
              </PopularItems>
            </PopularItemsContainer>
          )}
          {hideContinueCta ? (
            <></>
          ) : (
            <BottomCTA>
              <ButtonContainer>
                <PrimaryButton
                  isFullWidth
                  onClick={() => {
                    handleSubmit();
                    setSearchInput('');
                    setShowSearch(false);
                  }}
                  disabled={updatedSelection?.length < 1}
                >
                  <ButtonText>{continueCTA}</ButtonText>
                </PrimaryButton>
              </ButtonContainer>
            </BottomCTA>
          )}
        </MobileContent>
      )}
      {showSearch && (
        <SearchPage
          totalValues={totalValues}
          selectedValues={updatedSelection}
          handleAdd={(updatedList) => {
            setUpdatedSelection(updatedList);
            setShowSearch(false);
            setSearchInput('');
          }}
          searchInput={searchInput}
          isDesktop={!isMobile}
        />
      )}
    </MobileContainer>
  );
};

export default Index;
